import { WarningFilled } from "@ant-design/icons";
import { Typography } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ErrorView from "~components/Error";

const ScopeErrorPage = () => {
  const { state } = useLocation();
  const { statusCode = "", error = "" } = state || {};
  const navigate = useNavigate();
  const { customerId } = useParams();
  const goToOrganizations = () => navigate(`/${customerId}/select/organization`);

  const ErrorDetails = (
    <>
      <Typography.Text>{`Status code: ${statusCode}`}</Typography.Text>
      <br />
      {error}
    </>
  );

  return (
    <ErrorView
      titleIntlKey="error.unexpected"
      descriptionIntlKey="error.unexpected.scope.description"
      actionButtonIntlKey="back.to.organizations"
      details={ErrorDetails}
      Icon={WarningFilled}
      onActionButtonClick={goToOrganizations}
    />
  );
};

export default ScopeErrorPage;
